const Ticket = {
  path: "",
  name: "",
  redirect: "/ticket-activity",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/ticket-activity",
      redirect: "/ticket-activity",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Ticket Activity",
      meta: {
        requiresAuth: true,
        activeUrl: "/ticket-activity",
        parent: "ticket-activity",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/ticket/Index"),
          meta: {
            requiresAuth: true,
            activeUrl: "/ticket-activity",
            parent: "ticket-activity",

            lv: 2,
          },
        },
        {
          path: "/ticket-activity/create",
          name: "Ticket Activity Create",
          component: () => import("@/views/pages/ticket/activity/Create"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/ticket-activity",
            parent: "ticket-activity",

            lv: 3,
          },
        },
        {
          path: "/ticket-activity/detail/:ticketId",
          name: "Ticket Activity Detail",
          component: () => import("@/views/pages/ticket/activity/Detail"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/ticket-activity",
            parent: "ticket-activity",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Ticket;
